import dotProp from 'dot-prop-immutable'
import { connect } from 'react-redux'
import { movingFrame, stopMovingFrame } from "../../actions/project/draggable";
import DraggableProduct from './../../components/DraggableProduct'

const mapStateToProps = state => ({
  perMeter: dotProp.get(state, 'project.background.perMeter', 1000),
  isResizing: dotProp.get(state, 'project.allowToResize', false),
  crop: dotProp.get(state, 'project.background.crop', { width: 100, height: 100 } ),
  dim: dotProp.get(state, 'project.dim', { width: 100, height: 100 }),
})

const mapDispatchToProps = dispatch => ({
  onStopMove: (index, position) => dispatch(stopMovingFrame(index, position)),
  onMove: (index, position) => dispatch(movingFrame(index, position)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DraggableProduct)



// WEBPACK FOOTER //
// ./src/containers/DraggableProduct/index.js